export default __webpack_public_path__ + "static/saw-ed04947ac9e3cff871a109c7fde0fd2f.png";